import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { CompleteInviteFriendsRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { CompleteInviteFriendsResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const completeInviteFriends = (request: CompleteInviteFriendsRequest, options?: CashRequestOptions) =>
  post<CompleteInviteFriendsRequest, CompleteInviteFriendsResponse>('/2.0/cash/complete-invite-friends', request, {
    ...options,
    rejectOnError: true,
  })
